"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgba = void 0;
const hex_rgb_1 = __importDefault(require("hex-rgb"));
exports.rgba = (hexCode, alpha) => {
    const channels = hex_rgb_1.default(hexCode);
    return `rgba(${channels.red}, ${channels.green}, ${channels.blue}, ${alpha})`;
};
